export const BLOG_POSTS = [
  {
    slug: "guia-compra-coche-segunda-mano-espana",
    title: "Guia 2026 para comprar coche de segunda mano en Espana sin errores caros",
    description:
      "Checklist practico para revisar precio, historial, kilometraje, mantenimiento y riesgo legal antes de comprar un coche usado.",
    publishedAt: "2026-04-18",
    readTime: "8 min",
    category: "Compra inteligente",
    intro:
      "Comprar un coche usado puede ser una gran decision o un problema caro. Esta guia resume un proceso claro para reducir riesgo y negociar mejor.",
    sections: [
      {
        heading: "1) Valida primero el encaje financiero real",
        paragraphs: [
          "No te quedes solo con el precio de compra. Calcula coste total mensual: financiacion, seguro, combustible, mantenimiento y posibles averias.",
          "Como regla rapida, intenta que el coste total del coche no supere el 20% de tus ingresos netos mensuales si no tienes otras deudas relevantes.",
        ],
      },
      {
        heading: "2) Contrasta el precio con mercado real",
        paragraphs: [
          "Compara al menos 20 anuncios equivalentes: mismo modelo, motorizacion, ano, kilometraje y acabado.",
          "Si una unidad esta muy por debajo del rango, exige explicaciones documentadas. Lo barato sin trazabilidad suele salir caro.",
        ],
      },
      {
        heading: "3) Revisa historial y trazabilidad",
        bullets: [
          "Informe de vehiculo y titularidad al dia.",
          "Libro de mantenimiento o facturas verificables.",
          "ITV coherente con kilometraje y fechas.",
          "Comprobacion de cargas o reservas de dominio antes de firmar.",
        ],
      },
      {
        heading: "4) Inspeccion tecnica minima antes de reservar",
        bullets: [
          "Arranque en frio y test de ruidos anormales.",
          "Revision de humos, vibraciones y cambios de marcha.",
          "Desgaste irregular de neumaticos y frenos.",
          "Comprobacion de fugas y estado de bateria.",
        ],
      },
      {
        heading: "5) Negociacion basada en datos",
        paragraphs: [
          "Negocia sobre hechos: mantenimientos pendientes, neumaticos, frenos, pequenos danos y dispersion de precio frente a mercado.",
          "Pide por escrito lo acordado: garantia, fecha de entrega, kilometraje declarado y estado de elementos criticos.",
        ],
      },
    ],
    conclusion:
      "La compra inteligente no depende de encontrar un milagro, sino de reducir incertidumbre con un proceso. Cuanto mejor documentada este la operacion, menor riesgo asumiras.",
  },
  {
    slug: "renting-vs-compra-2026-que-conviene-segun-tu-uso",
    title: "Renting vs compra en 2026: que te conviene segun uso, kilometros y liquidez",
    description:
      "Analisis claro para decidir entre renting y compra segun horizonte de uso, estabilidad de ingresos y riesgo de depreciacion.",
    publishedAt: "2026-04-18",
    readTime: "7 min",
    category: "Decision de movilidad",
    intro:
      "No existe una respuesta universal. Renting y compra tienen sentido en escenarios distintos. Esta comparativa te ayuda a elegir con criterio economico.",
    sections: [
      {
        heading: "1) Cuando renting suele ganar",
        bullets: [
          "Quieres cuota predecible y evitar sorpresas de mantenimiento.",
          "Renuevas coche cada 3-5 anos.",
          "Priorizas liquidez y no quieres inmovilizar entrada alta.",
          "Buscas simplificar gestion (seguro, mantenimiento, asistencia).",
        ],
      },
      {
        heading: "2) Cuando compra suele ganar",
        bullets: [
          "Vas a mantener el coche muchos anos.",
          "Haces kilometraje estable y bien conocido.",
          "Puedes asumir mantenimiento con plan preventivo.",
          "Tu objetivo es reducir coste total tras amortizacion.",
        ],
      },
      {
        heading: "3) Variables clave para comparar bien",
        paragraphs: [
          "Compara coste total anual, no solo cuota. Incluye seguro, impuestos, neumáticos, mantenimientos, averias probables y valor futuro de reventa.",
          "Mide tambien el coste de oportunidad del dinero: entrada inicial, financiacion y liquidez que dejas de tener.",
        ],
      },
      {
        heading: "4) Errores frecuentes",
        bullets: [
          "Elegir por cuota mensual sin revisar limite de kilometros.",
          "Subestimar depreciacion en compra.",
          "No valorar penalizaciones por uso o devolucion en renting.",
          "Decidir sin escenario de ingresos y cambios familiares a 3 anos.",
        ],
      },
      {
        heading: "5) Regla practica para decidir",
        paragraphs: [
          "Si valoras estabilidad de gasto, flexibilidad de renovacion y menor carga operativa, renting suele encajar mejor.",
          "Si priorizas coste total a largo plazo y puedes gestionar el ciclo completo del vehiculo, compra suele ser superior.",
        ],
      },
    ],
    conclusion:
      "La mejor decision es la que encaja con tu uso real y tu contexto financiero. Un buen analisis previo evita cambiar de estrategia a mitad de camino.",
  },
];

// English translations for each post (merged over the base post when lang === "en")
const BLOG_POSTS_EN = {
  "guia-compra-coche-segunda-mano-espana": {
    title: "2026 Guide to Buying a Used Car in Spain Without Costly Mistakes",
    description:
      "A practical checklist to review price, history, mileage, maintenance and legal risk before buying a used car.",
    category: "Smart buying",
    intro:
      "Buying a used car can be a great decision or an expensive problem. This guide summarises a clear process to reduce risk and negotiate better.",
    sections: [
      {
        heading: "1) Validate the real financial fit first",
        paragraphs: [
          "Don't stop at the purchase price. Calculate the full monthly cost: financing, insurance, fuel, maintenance and possible repairs.",
          "As a quick rule, try to keep the total cost of the car below 20% of your net monthly income if you have no other significant debts.",
        ],
      },
      {
        heading: "2) Compare the price against the real market",
        paragraphs: [
          "Compare at least 20 equivalent listings: same model, engine, year, mileage and trim level.",
          "If a unit is well below the range, demand documented explanations. Cheap without traceability usually ends up being expensive.",
        ],
      },
      {
        heading: "3) Check history and traceability",
        bullets: [
          "Up-to-date vehicle and ownership report.",
          "Maintenance book or verifiable invoices.",
          "MOT consistent with mileage and dates.",
          "Check for charges or liens before signing.",
        ],
      },
      {
        heading: "4) Minimum technical inspection before reserving",
        bullets: [
          "Cold start and abnormal noise test.",
          "Check for fumes, vibrations and gear changes.",
          "Irregular tyre and brake wear.",
          "Check for leaks and battery condition.",
        ],
      },
      {
        heading: "5) Data-driven negotiation",
        paragraphs: [
          "Negotiate on facts: pending maintenance, tyres, brakes, minor damage and price spread vs. market.",
          "Get in writing what was agreed: warranty, delivery date, declared mileage and condition of critical components.",
        ],
      },
    ],
    conclusion:
      "Smart buying does not depend on finding a miracle, but on reducing uncertainty with a process. The better documented the operation, the lower the risk you assume.",
  },
  "renting-vs-compra-2026-que-conviene-segun-tu-uso": {
    title: "Renting vs Buying in 2026: What Works Best for Your Usage, Mileage and Cash Flow",
    description:
      "A clear analysis to decide between renting and buying based on your usage horizon, income stability and depreciation risk.",
    category: "Mobility decision",
    intro:
      "There is no universal answer. Renting and buying make sense in different scenarios. This comparison helps you choose with economic rationale.",
    sections: [
      {
        heading: "1) When renting tends to win",
        bullets: [
          "You want a predictable monthly payment and no maintenance surprises.",
          "You renew your car every 3-5 years.",
          "You prioritise liquidity and don't want to tie up a large deposit.",
          "You want to simplify management (insurance, maintenance, assistance).",
        ],
      },
      {
        heading: "2) When buying tends to win",
        bullets: [
          "You plan to keep the car for many years.",
          "You do a stable and well-known mileage.",
          "You can handle maintenance with a preventive plan.",
          "Your goal is to reduce total cost after amortisation.",
        ],
      },
      {
        heading: "3) Key variables for a proper comparison",
        paragraphs: [
          "Compare total annual cost, not just the monthly payment. Include insurance, taxes, tyres, maintenance, likely repairs and future resale value.",
          "Also measure the opportunity cost of money: upfront deposit, financing and liquidity you give up.",
        ],
      },
      {
        heading: "4) Common mistakes",
        bullets: [
          "Choosing based on monthly payment without checking the mileage limit.",
          "Underestimating depreciation on a purchase.",
          "Not accounting for use or return penalties in renting.",
          "Deciding without a 3-year income and family-change scenario.",
        ],
      },
      {
        heading: "5) Practical rule for deciding",
        paragraphs: [
          "If you value spending stability, renewal flexibility and lower operational burden, renting usually fits better.",
          "If you prioritise total long-term cost and can manage the full vehicle lifecycle, buying is usually superior.",
        ],
      },
    ],
    conclusion:
      "The best decision is the one that fits your actual usage and financial context. A good upfront analysis avoids having to change strategy midway.",
  },
};

export function getBlogPostBySlug(slug = "", lang = "es") {
  const post = BLOG_POSTS.find((p) => p.slug === slug) || null;
  if (!post) return null;
  if (lang === "en" && BLOG_POSTS_EN[slug]) {
    return { ...post, ...BLOG_POSTS_EN[slug] };
  }
  return post;
}

export function getLocalizedBlogPosts(lang = "es") {
  return BLOG_POSTS.map((post) => {
    if (lang === "en" && BLOG_POSTS_EN[post.slug]) {
      return { ...post, ...BLOG_POSTS_EN[post.slug] };
    }
    return post;
  });
}
